import * as yup from 'yup';
import { Resolver, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { cloneDeep } from 'lodash';
import { mainPageInitialValues } from '~/modules/main-page/utils.ts';
import { mainPageSchema } from '~/modules/identification/components/DataUpdate/validationSchemas.ts';
import { TAutocompleteOption } from '~/components/AutocompleteField/types';

export const useMainePageForm = () => {
  const initialValues = mainPageInitialValues();

  const schema = yup.lazy(() => mainPageSchema);

  const form = useForm<{ dataUpdateForms: TAutocompleteOption[] }>({
    resolver: yupResolver(schema) as unknown as Resolver<{
      dataUpdateForms: TAutocompleteOption[];
    }>,
    mode: 'onTouched',
    reValidateMode: 'onChange',
    shouldUnregister: false,
    defaultValues: cloneDeep(initialValues),
  });

  return form;
};
